const sanitizeString = (input) => input.replace(/[^a-zA-Z0-9-]/g, '');
export default sanitizeString;
